var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 14,
    viewBox: "0 0 19 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3496 7.98865C14.5167 8.8024 15.3346 9.9049 15.3346 11.3749V13.9999H18.7423V11.3749C18.7423 9.4674 15.7009 8.33865 13.3496 7.98865Z",
    fill: "#0C3094"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.81542 7C8.69745 7 10.2231 5.433 10.2231 3.5C10.2231 1.567 8.69745 0 6.81542 0C4.9334 0 3.40771 1.567 3.40771 3.5C3.40771 5.433 4.9334 7 6.81542 7Z",
    fill: "#0C3094"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.927 7C13.8098 7 15.3347 5.43375 15.3347 3.5C15.3347 1.56625 13.8098 0 11.927 0C11.5266 0 11.1518 0.0874998 10.7939 0.21C11.501 1.11125 11.927 2.2575 11.927 3.5C11.927 4.7425 11.501 5.88875 10.7939 6.79C11.1518 6.9125 11.5266 7 11.927 7Z",
    fill: "#0C3094"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.81542 7.875C4.54077 7.875 0 9.0475 0 11.375V14H13.6308V11.375C13.6308 9.0475 9.09006 7.875 6.81542 7.875Z",
    fill: "#0C3094"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClient);
export default __webpack_public_path__ + "static/media/client.68122beda1cd894c685daf1472ef3bd9.svg";
export { ForwardRef as ReactComponent };